import {
  JOB_APPLICATION_POSITION_SLUGS,
  type JobApplicationPositionSlug
} from '@algoacademy/backend/modules/notifications/job-application/constants'
import { z } from 'zod'

export { JOB_APPLICATION_POSITION_SLUGS, type JobApplicationPositionSlug }

const fullNameSegments = (value: string) =>
  value
    .trim()
    .split(/\s+/)
    .filter(s => s.length > 0)

export const jobApplicationSchemaZ = z.object({
  positionSlug: z.enum(JOB_APPLICATION_POSITION_SLUGS, {
    message: 'Wybierz stanowisko'
  }),
  fullName: z
    .string()
    .trim()
    .min(1, { message: 'Podaj imię i nazwisko' })
    .max(160, { message: 'Maksymalnie 160 znaków' })
    .refine(v => fullNameSegments(v).length >= 2, {
      message: 'Podaj imię i nazwisko (imię oraz nazwisko)'
    }),
  email: z.string().trim().email({ message: 'Podaj poprawny adres email' }),
  phone: z
    .string()
    .trim()
    .max(30)
    .refine(v => v === '' || /^\+?[0-9 \-()]{6,20}$/.test(v), 'Niepoprawny numer telefonu'),
  cvUrl: z
    .string()
    .trim()
    .max(2000)
    .refine(
      v => v === '' || /^https?:\/\/.+/.test(v),
      'Podaj pełny adres URL (http:// lub https://)'
    ),
  message: z.string().trim().max(4000, { message: 'Maksymalnie 4000 znaków' }),
  consentContact: z.boolean().refine(v => v === true, {
    message: 'Aby przesłać zgłoszenie, potrzebujemy zgody na kontakt w sprawie rekrutacji'
  }),
  consentMarketingOffers: z.boolean()
})

export type JobApplicationFormData = z.infer<typeof jobApplicationSchemaZ>

export function jobApplicationDefaultValues(
  positionSlug: JobApplicationPositionSlug
): JobApplicationFormData {
  return {
    positionSlug,
    fullName: '',
    email: '',
    phone: '',
    cvUrl: '',
    message: '',
    consentContact: false,
    consentMarketingOffers: false
  }
}
